import * as types from '../types/index'

export const adminAuthReducer = (state = { loading: false }, action) => {
	switch (action.type) {
		case types.AUTH_REQUEST:
			return { ...state, loading: true }
		case types.AUTH_SUCCESS:
			return { loading: false, detail: action.payload }
		case types.AUTH_FAIL:
			return { loading: false, error: action.payload }
		case types.AUTH_LOGOUT:
			return {}
		default:
			return state
	}
}

export const getAdminProfileReducer = (state = { profile: {} }, action) => {
	switch (action.type) {
		case types.GET_ADMIN_PROFILE_REQUEST:
			return { ...state, loading: true, profile: {} }
		case types.GET_ADMIN_PROFILE_SUCCESS:
			return { loading: false, profile: action.payload }
		case types.GET_ADMIN_PROFILE_FAIL:
			return { loading: false, error: action.payload, profile: {} }
		case types.GET_ADMIN_PROFILE_RESET:
			return {}
		default:
			return state
	}
}

export const adminUpdateProfileReducer = (state = {}, action) => {
	switch (action.type) {
		case types.UPDATE_ADMIN_PROFILE_REQUEST:
			return { loading: true }
		case types.UPDATE_ADMIN_PROFILE_SUCCESS:
			return { loading: false, success: true, detail: action.payload }
		case types.UPDATE_ADMIN_PROFILE_FAIL:
			return { loading: false, error: action.payload }
		case types.UPDATE_ADMIN_PROFILE_RESET:
			return {}
		default:
			return state
	}
}

// export const userRegisterReducer = (state = {}, action) => {
// 	switch (action.type) {
// 		case types.USER_REGISTER_REQUEST:
// 			return { loading: true }
// 		case types.USER_REGISTER_SUCCESS:
// 			return { loading: false, userDetail: action.payload }
// 		case types.USER_REGISTER_FAIL:
// 			return { loading: false, error: action.payload }
// 		case types.USER_REGISTER_RESET:
// 			return {}
// 		default:
// 			return state
// 	}
// }
